import React from 'react';
import PropTypes from 'prop-types';
import { SaveButton } from 'react-admin';

const getClassName = (state) => {
    return state ? "tooltip-for-save-button" : "tooltip-for-save-button--off"
}

const SaveButtonAware = ({ invalid, ...rest }) => (
        <div className="save-button-aware">
            <SaveButton disabled={invalid} {...rest} />
            <p className={getClassName(invalid)}>Необхідно заповнити усі обов'язкові поля у формі</p>
        </div>
    );

SaveButtonAware.propTypes = {
    invalid: PropTypes.bool,
};

export default SaveButtonAware;
